import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import { g500, flamingo } from '../colors';
/*::
import type { Node } from 'react';

export type IconProps = {|
  color?: string,
  strokeColor?: string,
  checked?: boolean,
  width?: number,
  height?: number,
|}
*/

var WDZ = 15;
var HGT = 15;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var CheckBox = function CheckBox(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? flamingo() : _ref$color,
      _ref$strokeColor = _ref.strokeColor,
      strokeColor = _ref$strokeColor === void 0 ? g500() : _ref$strokeColor,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "strokeColor", "checked", "width", "height"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem"
    }
  }, rest), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "15",
    rx: "2",
    fill: color,
    className: "filled-rect",
    display: checked ? 'inherit' : 'none'
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.85",
    y: "0.85",
    width: "13.3",
    height: "13.3",
    rx: "1.15",
    stroke: strokeColor,
    strokeWidth: "1.7",
    className: "stroke-rect",
    display: !checked ? 'inherit' : 'none'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.92233L6.33971 11L12 4",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "square",
    className: "tick",
    display: checked ? 'inherit' : 'none'
  }));
};

export default CheckBox;